import Image from 'next/image';
import Link from 'next/link';
import React, { ReactElement } from 'react';

import { Assets } from '../../../../../utils/assets';
import { SecondaryButtonLink } from '../../../../button';
import MaxWidth from '../../../../shared/MaxWidth';
import * as S from './Join.styles';

export const Join = (): ReactElement => {
  return (
    <S.Wrapper>
      <S.GradientLeft
        alt={Assets.images.ctaLandingGradientLeft.alt}
        src={Assets.images.ctaLandingGradientLeft.url}
      />
      <MaxWidth>
        <S.Content>
          <S.TextBox>
            <S.Caption>Want to join our team?</S.Caption>
            <S.Description>
              We’re always on the lookout for some mad talent, be sure to let us know if you think
              you’d be a right fit.
            </S.Description>
            <S.ButtonWrapper>
              <Link href="/jobs" prefetch={!process.env.STORYBOOK}>
                <SecondaryButtonLink
                  analyticsEvent={{
                    category: 'About Us: Join Us',
                    action: 'Contact Page Link Click',
                  }}
                  isAnchortag={false}
                >
                  SEE OPEN POSITIONS
                </SecondaryButtonLink>
              </Link>
            </S.ButtonWrapper>
          </S.TextBox>
          <S.VisualBlock>
            <Image
              alt={Assets.images.teamPhoto.alt}
              height={648}
              loading="lazy"
              src={Assets.images.teamPhoto.url}
              style={{ height: 'auto', width: '100%' }}
              width={568}
            />
          </S.VisualBlock>
        </S.Content>
      </MaxWidth>
    </S.Wrapper>
  );
};
